import React, { Component } from 'react'
import Loader from 'react-loader-advanced'
import { connect } from 'react-redux'
import * as Constants from '../../../common/constants'

class MainContent extends Component {


     checkUserAccess = (handle,userPrivileges) =>{
     
            if(userPrivileges && userPrivileges!==undefined && userPrivileges.length>0){
                let flagCheck=false;
                userPrivileges.map(function(item) {
                    if(item.app_access===handle){
                        flagCheck=true;
                        }
                        return true
                     });

                    if(handle==="/dashboard/resetpassword" || handle==="/dashboard/products" || handle==="/dashboard" || handle==="/login" || handle==="/forgot" || handle==="/logout"){
                        flagCheck=true;
                    }

                    return flagCheck
            }else{
                this.props.history.push("/login");
            }
        }

    isLoaderIsNeeded = (pageLoaded,userPrivileges) => {

        if(!this.checkUserAccess(window.location.pathname,userPrivileges)){
            
            if(userPrivileges && userPrivileges.length>0){
                //this.props.history.push(userPrivileges[0].app_access)

                if(window.location.pathname==="/dashboard/products/list"){
                    let onlyListPages=userPrivileges.filter(item => item.app_access.includes("list"))
                    this.props.history.push(onlyListPages[0].app_access)
                }else{

                        let onlyListPages=userPrivileges.filter(item => item.app_access.includes("list"))
                        this.props.history.push(onlyListPages[0].app_access)
                        alert("Sorry, you don't have access for this page. Please contact admin.")
                        this.props.history.push(onlyListPages[0].app_access)
                }
               
            }else{

                this.props.history.push("/login");
            }
        }


        switch(pageLoaded) {
            case Constants.ORDERS_TABLE:
                    if(this.props.orders.isOrdersTableReady) {
                        return true
                    } else {
                        return false
                    }

            case Constants.ORDER_GROUPS_TABLE:
                if(this.props.orderGroups.isOrderGroupsTableReady){
                    return true
                }else{
                    return false
                }
            
            case Constants.CUSTOMER_LIST:
                if(this.props.customers.isCustomersTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.COMPANY_LIST:
                if(this.props.companies.isCompaniesTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.SELLERS_TABLE:
                if(this.props.sellers.isSellersTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.DAILY_MENU_TABLE:
                if(this.props.dailyMenus.isDailyMenusTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.PRODUCT_LIST:
                if (this.props.products && this.props.products.isProductsTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.PRODUCTS_STOCKS_LIST:
                if (this.props.products_stocks && this.props.products_stocks.isProductsStocksTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.PRODUCTS_UPDATE_STOCKS_TABLE:
                if (this.props.products_stocks && this.props.products_stocks.isProductUpdateStockTableReady) {
                    return true
                } else {
                    return false
                }


            case Constants.PRIVILEGES_TABLE:
                if (this.props.privileges && this.props.privileges.isPrivilegesTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_PRIVILEGES:
                if (this.props.privileges && this.props.privileges.isAddEditPrivilegesReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_PRIVILEGES:
                if (this.props.privileges && this.props.privileges.isAddEditPrivilegesReady) {
                    return true
                } else {
                    return false
                }
            
            case Constants.KITS_TABLE:
                if (this.props.kits && this.props.kits.isKitsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.KITS_PRODUCTS_TABLE:
                if (this.props.kits && this.props.kits.isKitsProductsTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.KITS_PRODUCTS_UPDATE_TABLE:
                if (this.props.kits && this.props.kits.isKitsProductsUpdateTableReady) {
                    return true
                } else {
                    return false
                }


            case Constants.KITS_STORES:
                if (this.props.kits && this.props.kits.isKitsStoresTableReady) {
                        return true
                    } else {
                        return false
                    }
            case Constants.KITS_STORES_UPDATE_LOCATION:
                if (this.props.kits && this.props.kits.isKitsUpdateLocationTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.BRANDS_TABLE:
                if(this.props.brands.isBrandsTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_BRAND:
                if(this.props.brands.isAddEditBrandReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_BRAND:
                if(this.props.brands.isAddEditBrandReady) {
                    return true
                } else {
                    return false
                }

            case Constants.CITIES_TABLE:
                if(this.props.cities.isCitiesTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.STORES_TABLE:
                if(this.props.stores.isStoresTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.STORES_TICKETS_TABLE:
                if(this.props.stores.isStoresTicketsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ST_AGENTS_TABLE:
                if(this.props.stores.isStoreTicketsAgentsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ST_AGENT_KITCHENS:
                if(this.props.stores.isAddSTAgentKitchensReady) {
                    return true
                } else {
                    return false
                }                
            case Constants.CLUSTERS_TABLE:
                if(this.props.clusters.isClustersTableReady) {
                    return true
                } else {
                    return false
                }          
            case Constants.ADD_CLUSTER:
                if(this.props.clusters.isAddEditClusterReady) {
                    return true
                } else {
                    return false
                }
      
            case Constants.EDIT_CLUSTER:
                if(this.props.clusters.isAddEditClusterReady) {
                    return true
                } else {
                    return false
                }


            case Constants.KITCHENS_TABLE:
                if(this.props.kitchens.isKitchensTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_KITCHEN:
                if(this.props.kitchens.isAddEditKitchenReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_KITCHEN:
                if(this.props.kitchens.isAddEditKitchenReady) {
                    return true
                } else {
                    return false
                }
            case Constants.VIEW_KITCHEN_TEAM:
                if(this.props.kitchens.isViewKitchenTeamTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_EDIT_STORE_TIMING:
                if(this.props.stores.isStoreAddEditTimingReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EMPLOYEE_RESOURCES_TABLE:
                if(this.props.employees.isEmployeeResourcesTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EMPLOYEES_TABLE:
                if(this.props.employees.isEmployeesTableReady) {
                    return true
                } else {
                    return false
                }


            case Constants.ADD_EMPLOYEE:
                if(this.props.employees.isAddEditEmployeeReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_EMPLOYEE:
                if(this.props.employees.isAddEditEmployeeReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ROLES_TABLE:
                if(this.props.roles.isRolesTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_ROLE:
                if (this.props.roles && this.props.roles.isAddEditRolesReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_ROLE:
                if (this.props.roles && this.props.roles.isAddEditRolesReady) {
                    return true
                } else {
                    return false
                }



            case Constants.DESIGNATIONS_TABLE:
                if(this.props.designations.isDesignationsTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_DESIGNATION:
                if (this.props.designations && this.props.designations.isAddEditDesignationsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_DESIGNATION:
                if (this.props.designations && this.props.designations.isAddEditDesignationsReady) {
                    return true
                } else {
                    return false
                }


            case Constants.EDIT_STORE_TICKET:
                if (this.props.stores && this.props.stores.isStoreTicketUpdateReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ASSIGN_AGENT_STORE_TICKET:
                if (this.props.stores && this.props.stores.isAssignAgentStoreTicketUpdateReady) {
                    return true
                } else {
                    return false
                }


            case Constants.STORES_TICKETS_LIVE_TABLE:
                if (this.props.stores && this.props.stores.isStoresTicketsLiveTableReady) {
                    return true
                } else {
                    return false
                }


         case Constants.REASONS_TABLE:
                if(this.props.reasons.isReasonsTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_REASON:
                if (this.props.reasons && this.props.reasons.isAddEditReasonsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_REASON:
                if (this.props.reasons && this.props.reasons.isAddEditReasonsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.RESET_PASSWORD:
                if (this.props.user && this.props.user.isResetPageReady) {
                    return true
                } else {
                    return false
                }

             case Constants.COSTCENTERS_TABLE:
                if(this.props.costCenters.isCostCentersTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_COSTCENTER:
                if (this.props.costCenters && this.props.costCenters.isAddEditCostCentersReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_COSTCENTER:
                if (this.props.costCenters && this.props.costCenters.isAddEditCostCentersReady) {
                    return true
                } else {
                    return false
                }

             case Constants.DEPARTMENTS_TABLE:
                if(this.props.departments.isDepartmentsTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_DEPARTMENT:
                if (this.props.departments && this.props.departments.isAddEditDepartmentsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_DEPARTMENT:
                if (this.props.departments && this.props.departments.isAddEditDepartmentsReady) {
                    return true
                } else {
                    return false
                }

             case Constants.WORKLOCATIONS_TABLE:
                if(this.props.workLocations.isWorkLocationsTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_WORKLOCATION:
                if (this.props.workLocations && this.props.workLocations.isAddEditWorkLocationsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_WORKLOCATION:
                if (this.props.workLocations && this.props.workLocations.isAddEditWorkLocationsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_EMPLOYEE_ATTRITION:
                if (this.props.teams && this.props.teams.isAddEmployeeAttritionReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EMPLOYEES_MOVEMENT_TABLE:
                if (this.props.employeesmovement && this.props.employeesmovement.isEmployeesMovementTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_EMPLOYEE_MOVEMENT:
                if (this.props.employeesmovement && this.props.employeesmovement.isAddEmployeeMovementReady) {
                    return true
                } else {
                    return false
                }

            case Constants.VIEW_EMPLOYEE:
                if (this.props.employees && this.props.employees.isViewEmployeeReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EMPLOYEES_ATTRITION_TABLE:
                if (this.props.employees && this.props.employees.isEmployeesAttritionTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.EDIT_EMPLOYEE_ATTRITION:
                if (this.props.employees && this.props.employees.isEditEmployeeAttritionReady) {
                    return true
                } else {
                    return false
                }


            case Constants.TEAMS_TABLE:
                if (this.props.teams && this.props.teams.isTeamsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ATTENDANCE_TABLE:
                if (this.props.teams && this.props.teams.isAddAttendanceTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.HR_TICKETS_TABLE:
                if (this.props.hr && this.props.hr.isHRTicketsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_HR_TICKET:
                if (this.props.hr && this.props.hr.isAddEditHRTicketsReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_HR_TICKET:
                if (this.props.hr && this.props.hr.isAddEditHRTicketsReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ST_REPORTS_TABLE:
                if (this.props.streports && this.props.streports.isSTReportsReady) {
                    return true
                } else {
                    return false
                }
            case Constants.DEPARTMENT_TEAMS_TABLE:
                if (this.props.departmentTeams && this.props.departmentTeams.isDepartmentTeamsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_DEPARTMENT_TEAM:
                if (this.props.departmentTeams && this.props.departmentTeams.isAddEditDepartmentTeamsReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_DEPARTMENT_TEAM:
                if (this.props.departmentTeams && this.props.departmentTeams.isAddEditDepartmentTeamsReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ADD_STORE:
                if (this.props.stores && this.props.stores.isAddEditStoreReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_STORE:
                if (this.props.stores && this.props.stores.isAddEditStoreReady) {
                    return true
                } else {
                    return false
                }
            case Constants.CATEGORIES_TABLE:
                if (this.props.categories && this.props.categories.isCategoriesTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_CATEGORY:
                if (this.props.categories && this.props.categories.isAddEditCategoryReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_CATEGORY:
                if (this.props.categories && this.props.categories.isAddEditCategoryReady) {
                    return true
                } else {
                    return false
                }
            case Constants.MENUS_TABLE:
                if (this.props.menus && this.props.menus.isMenusTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_MENU:
                if (this.props.menus && this.props.menus.isAddEditMenuReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_MENU:
                if (this.props.menus && this.props.menus.isAddEditMenuReady) {
                    return true
                } else {
                    return false
                }
            case Constants.MENU_DISABLED_TICKETS_TABLE:
                if (this.props.menu_disabled_tickets && this.props.menu_disabled_tickets.isMenuDisabledTicketsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_MENU_DISABLED_TICKET:
                if (this.props.menu_disabled_tickets && this.props.menu_disabled_tickets.isMenuDisabledTicketUpdateReady) {
                    return true
                } else {
                    return false
                }

            case Constants.KITCHEN_STAFFS_TABLE:
                if (this.props.kitchen_staffs && this.props.kitchen_staffs.isKitchenStaffsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_KITCHEN_STAFF:
                if (this.props.kitchen_staffs && this.props.kitchen_staffs.isAddEditKitchenStaffReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_KITCHEN_STAFF:
                if (this.props.kitchen_staffs && this.props.kitchen_staffs.isAddEditKitchenStaffReady) {
                    return true
                } else {
                    return false
                }

            case Constants.USERS_TABLE:
                if (this.props.users && this.props.users.isUsersTableReady) {
                    return true
                } else {
                    return false
                }
             case Constants.EMPLOYEE_DEPUTE_TABLE:
                if (this.props.employee_depute && this.props.employee_depute.isEmployeeDeputeTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_EMPLOYEE_DEPUTE:
                if (this.props.employee_depute && this.props.employee_depute.isAddEmployeeDeputeReady) {
                    return true
                } else {
                    return false
                }
             case Constants.EMPLOYEE_REHIRE_TABLE:
                if (this.props.employee_rehire && this.props.employee_rehire.isEmployeeRehireTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_EMPLOYEE_REHIRE:
                if (this.props.employee_rehire && this.props.employee_rehire.isAddEmployeeRehireReady) {
                    return true
                } else {
                    return false
                }
             case Constants.EMPLOYEE_PROMOTION_TABLE:
                if (this.props.employee_promotion && this.props.employee_promotion.isEmployeePromotionTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_EMPLOYEE_PROMOTION:
                if (this.props.employee_promotion && this.props.employee_promotion.isAddEmployeePromotionReady) {
                    return true
                } else {
                    return false
                }
             case Constants.ATTENDANCE_TABLE:
                if (this.props.attendances && this.props.attendances.isAttendanceTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ATTENDANCE:
                if (this.props.attendances && this.props.attendances.isAddEditAttendanceReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_ATTENDANCE:
                if (this.props.attendances && this.props.attendances.isAddEditAttendanceReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ORDER_VERIFICATION_TABLE:
                if (this.props.order_verification && this.props.order_verification.isOrderVerificationTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ATTENDANCE_CYCLES_TABLE:
                if (this.props.attendance_cycles && this.props.attendance_cycles.isAttendanceCyclesTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EMPLOYEE_PAY_SCALES_TABLE:
                if (this.props.employee_pay_scales && this.props.employee_pay_scales.isEmployeePayScalesTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_EMPLOYEE_PAY_SCALE:
                if (this.props.employee_pay_scales && this.props.employee_pay_scales.isAddEditEmployeePayScaleReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_EMPLOYEE_PAY_SCALE:
                if (this.props.employee_pay_scales && this.props.employee_pay_scales.isAddEditEmployeePayScaleReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ENTITY_TYPES_TABLE:
                if (this.props.entity_types && this.props.entity_types.isEntityTypesTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ENTITY_TYPE:
                if (this.props.entity_types && this.props.entity_types.isAddEditEntityTypeReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_ENTITY_TYPE:
                if (this.props.entity_types && this.props.entity_types.isAddEditEntityTypeReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ENTITY_STATUS_TABLE:
                if (this.props.entity_status && this.props.entity_status.isEntityStatusTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ENTITY_STATUS:
                if (this.props.entity_status && this.props.entity_status.isAddEditEntityStatusReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_ENTITY_STATUS:
                if (this.props.entity_status && this.props.entity_status.isAddEditEntityStatusReady) {
                    return true
                } else {
                    return false
                }

            case Constants.PLATFORMS_TABLE:
                if (this.props.platforms && this.props.platforms.isPlatformsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_PLATFORM:
                if (this.props.platforms && this.props.platforms.isAddEditPlatformsReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_PLATFORM:
                if (this.props.platforms && this.props.platforms.isAddEditPlatformsReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ATTENDANCE_SUMMARY_TABLE:
                if (this.props.attendance_summary && this.props.attendance_summary.isAttendanceSummaryReady) {
                    return true
                } else {
                    return false
                }
            case Constants.NEW_JOINEE_TABLE:
                if (this.props.newjoinee && this.props.newjoinee.isNewJoineeTableReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ASSETS_TABLE:
                if (this.props.assets && this.props.assets.isAssetsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ASSET:
                if (this.props.assets && this.props.assets.isAddEditAssetReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_ASSET:
                if (this.props.assets && this.props.assets.isAddEditAssetReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ASSET_TYPES_TABLE:
                if (this.props.assetTypes && this.props.assetTypes.isAssetTypesTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ASSET_TYPE:
                if (this.props.assetTypes && this.props.assetTypes.isAddEditAssetTypeReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_ASSET_TYPE:
                if (this.props.assetTypes && this.props.assetTypes.isAddEditAssetTypeReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ASSET_VENDORS_TABLE:
                if (this.props.assetVendors && this.props.assetVendors.isAssetVendorsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_ASSET_VENDOR:
                if (this.props.assetVendors && this.props.assetVendors.isAddEditAssetVendorReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ASSET_VENDOR:
                if (this.props.assetVendors && this.props.assetVendors.isAddEditAssetVendorReady) {
                    return true
                } else {
                    return false
                }

            case Constants.ASSET_LOCATIONS_TABLE:
                if (this.props.assetLocations && this.props.assetLocations.isAssetLocationsTableReady) {
                    return true
                } else {
                    return false
                }
            case Constants.ADD_ASSET_LOCATION:
                if (this.props.assetLocations && this.props.assetLocations.isAddEditAssetLocationReady) {
                    return true
                } else {
                    return false
                }
            case Constants.EDIT_ASSET_LOCATION:
                if (this.props.assetLocations && this.props.assetLocations.isAddEditAssetLocationReady) {
                    return true
                } else {
                    return false
                }


            default:
                return true
        }
    }

    render() {
        let isMainContentReady = false
        let pageLoaded = ""
        let userPrivileges = []

         


        if(this.props.user && this.props.user.headerTitle) {
            pageLoaded = this.props.user.headerTitle
            let privilegesObj = this.props.user.privileges
            let pri=Object.entries(privilegesObj);

            pri.map(function(item) { 
                userPrivileges.push({"name":item[1].name,"api_access":item[1].api_access,"app_access":item[1].app_access}) 
                 return true   
            })

        }

        if(this.isLoaderIsNeeded(pageLoaded,userPrivileges)) {
            isMainContentReady = true
        } else {
            isMainContentReady = false
        }

        if (this.props.user && this.props.user.isLoading) {
            isMainContentReady = false
        }

        return (
            <div className="content-wrapper loader-container-class" style={{
                backgroundColor: '#f0f0f0'
            }}>
                <Loader
                    show={!isMainContentReady}
                    message={'Loading...'}
                    foregroundStyle={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
                    {this.props.children}
                </Loader>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        brands: state.brands,
        cities: state.cities,
        clusters:state.clusters,
        products_stocks: state.products_stocks,
        kits: state.kits,
        kitchens: state.kitchens,
        stores:state.stores,
        orders: state.orders,
        orderGroups:state.orderGroups,
        sellers: state.sellers,
        dailyMenus: state.dailyMenus,
        products: state.products,
        customers: state.customers,
        companies: state.companies,
        privileges: state.privileges,
        employees:state.employees,
        roles:state.roles,
        designations:state.designations,
        reasons:state.reasons,
        costCenters:state.costCenters,
        departments:state.departments,
        workLocations:state.workLocations, 
        teams:state.teams,
        hr:state.hr,
        streports:state.streports,
        departmentTeams:state.departmentTeams,
        employeesmovement:state.employeesmovement,
        categories:state.categories,
        menus:state.menus,
        menu_disabled_tickets:state.menu_disabled_tickets,
        kitchen_staffs:state.kitchen_staffs,
        users:state.users,
        employee_depute:state.employee_depute,
        employee_rehire:state.employee_rehire,
        employee_promotion:state.employee_promotion,
        attendances:state.attendances,
        order_verification:state.order_verification,
        attendance_cycles:state.attendance_cycles,
        employee_pay_scales:state.employee_pay_scales,
        entity_types:state.entity_types,
        entity_status: state.entity_status,
        platforms: state.platforms,
        attendance_summary:state.attendance_summary,
        newjoinee:state.newjoinee,
        assets:state.assets,
        assetTypes:state.assetTypes,
        assetVendors:state.assetVendors,
        assetLocations:state.assetLocations,
        equipments:state.equipments

    }
}

export default connect(mapStateToProps)(MainContent)


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Components/MainContent.js